import React from 'react'
import AnnouncementContainer from '@/src/components/announcements'

const Research = () => {
  return <AnnouncementContainer category="research" />
}
export default Research
